import {
    clearAuxResourceName,
    clearAuxResourceUrl,
    clearExperienceMarker,
    clearMapBounds,
    setRenderMapBounds
} from "../helpers/commit_helpers";
import { requestNavClose } from "../helpers/nav_helpers";

export default function mapClicked(sm) {
    // Navigate away from any experience specific route.

    const mapFilter = sm.state['mapFilter'];
    const experienceMarker = sm.state['experienceMarker'];
    if (mapFilter && experienceMarker) {
        // Because there is an experienceMarker present we do not wish for the mapFilter's mapBounds to cause the map to pan/zoom when the experienceMarker is deselected.
        // Navigating to a mapFilter could cause this, so we turn off rendering of map bounds now and turn it back on after the navigation.
        setRenderMapBounds(sm, false);

        const router = mapFilter.onlineAppNavOption?.onlineApp?.onlineAppRouter
        if (router) router.navigateToFilter(mapFilter);

        setRenderMapBounds(sm, true);
    }

    clearMapBounds(sm);
    requestNavClose(); // Request the Nav to close (it owns navOpen); reflected back as navOpenReflected.
    clearExperienceMarker(sm);
    clearAuxResourceUrl(sm);
    clearAuxResourceName(sm);
}